import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProceduresFormComponent } from './procedures-form.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DxDataGridModule } from 'devextreme-angular';
import {TdoControlsModule} from '../../../../tdo-controls/tdo-controls.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';


@NgModule({
    declarations: [
        ProceduresFormComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule, MatSnackBarModule, DxDataGridModule, TdoControlsModule, MatProgressSpinnerModule
    ]
})
export class ProceduresFormModule { }
